import React from 'react'
import styles from './pages.module.scss'

const Gallery = () => {
  return <div className={styles.gallery}>Gallery</div>
}

export default Gallery
